import Glide from '@glidejs/glide';

import React, { Component } from 'react';
import ReactDOM from 'react-dom';

/**
 * React Glide Carousel
 * This is the Vertical Carousel used to display feature screenshots
 * inside of a mock laptop background.
 * 
 * @param props { features: { featureTitle, image: {} }[] }
 */
export class ReactGlideCarousel extends Component {
    
    constructor() {
        super();
        this.isMobile = window.innerWidth < 768;
        this.id = 'react-glide-carousel-' + Math.round(Math.random() * 10e6);
        this.bulletEnterTimeout = null;
    }
    
    componentDidMount() {
        this.slider = new Glide('#' + this.id, this.isMobile ? {peek: 0, perView: 1, autoplay: 5000, gap: 0} : {});
        const FixSizes = (Glide, Components, Events) => {
            /**
             * Fix absolutely positioned container issue
             * @devnote this should be fixed in source down the line
             * @see https://github.com/yoanmarchal/glide/blob/19125ce6813fdba567730d4b265154a5a0abe9d4/src/components/sizes.js
             */
            const fix = {
                get length() {
                    return Components.Html.slides.length;
                },
                get slideWidth() {
                    return (Components.Html.track.offsetWidth / Glide.settings.perView) - Components.Peek.reductor - Components.Gaps.reductor;
                },
                setupSlides() {
                    let slideWidth = fix.slideWidth;
                    let width = `${slideWidth}px`
                    let slides = Components.Html.slides

                    for (let i = 0; i < slides.length; i++) {
                        slides[i].style.width = width
                    }
                },
                setupWrapper() {
                    let wrapperSize = fix.slideWidth * fix.length + Components.Gaps.grow + Components.Clones.grow;
                    Components.Html.wrapper.style.width = `${wrapperSize}px`;
                }
            }
            Events.on(['build.before', 'resize', 'update'], () => {
                fix.setupSlides();
                fix.setupWrapper();
            });
            return fix;
        };
        const FixTranslate = (Glide, Components, Events) => {
            return {
                /**
                 * Modifies translate value to account for slide resizing above
                 *
                 * @param  {Number} translate
                 * @return {Number}
                 */
                modify(translate) {
                    return translate / 2;
                }
            }
        };
        setTimeout(() => this.isMobile ? this.slider.mount() : this.slider.mutate([FixTranslate]).mount({ 'FixSizes': FixSizes }));
    }

    slide(slide, index) {
        return (
            <li className='glide__slide' key={index}>
                <img className='glide__slide__image' src={slide.image.url} alt={slide.image.alt||slide.image.title}/>
                {this.isMobile && 
                    <div className="glide__slide__caption">{slide.title}</div>
                }
            </li>
        );
    }

    bulletEnter(i) {
        this.bulletEnterTimeout = setTimeout(() => this.slider.go('='+i), 150);
    }

    bulletLeave() {
        clearTimeout(this.bulletEnterTimeout);
    }

    bullets(slides) {
        return ( 
            <div className="glide__bullets" data-glide-el="controls[nav]">
                {slides.map((slide, i) => (
                    <button onMouseEnter={() => this.bulletEnter(i)} onMouseLeave={() => this.bulletLeave()} className="glide__bullet" key={i} data-glide-dir={'=' + i}>
                        <span className="hoverable">{slide.title}</span>
                        <span className="sr-only">Go to slide {i+1}</span>
                    </button>
                ))}
            </div>
        );
    }
    
    render() {
		return (
			<div className='react-glide-carousel glide' id={this.id}>
                <div className="glide__track__wrapper">
                    {!this.mobile && 
                        <img className='glide__track__surround' src='/assets/images/laptop-surround@2x.png' alt="Laptop surround"/>
                    }
                    <div className="glide__track__positioner">
                        <div className='glide__track' data-glide-el='track'>
                            <ul className='glide__slides'>
                                {this.props.slides.map((slide, i) => this.slide(slide, i))}
                            </ul>
                        </div>
                    </div>
                </div>
                {!this.isMobile &&
                    <div className="glide__bullets__wrapper">
                        {this.bullets(this.props.slides)}
                    </div>
                }
            </div>
		);
    }
    
}

const reactGlideCarouselElements = Array.from(
	document.querySelectorAll('[data-react-component="ReactGlideCarousel"]')
);
if (reactGlideCarouselElements.length) {
	reactGlideCarouselElements.forEach(el => {
		if (el.dataset.reactProps) {
            try {
                const props = JSON.parse(el.dataset.reactProps);
                ReactDOM.render(<ReactGlideCarousel slides={props.slides} />, el);
            } catch (error) {
                console.error("Error with Props", error);
            }
		} else {
			console.log('Missing required props');
		}
	});
}
